export default __webpack_public_path__ + "static/media/loggly.bf1191ff.svg";